import './index.less';
import * as React from 'react';
import classNames from 'classnames';

export type BottomSize  = 'default' | 'sm';

export interface BottomFixedProps {
  prefixCls?: string;
  children: React.ReactNode;
  className?: string;
  size?: BottomSize;
}

const BottomFixed: React.SFC<BottomFixedProps> = (props) => {
  const { prefixCls = 'mpc', children, className, size = 'default' } = props;
  const classes = classNames({
    [`${prefixCls}-bottom-fixed`]: true,
    [`${prefixCls}-bottom-fixed-size-${size}`]: true,
  }, className);

  return (
    <div className={classes}>
      {children}
    </div>
  );
};

export default BottomFixed;
